<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-container">
    <app-line-direction-counters-reset-menu></app-line-direction-counters-reset-menu>
    <app-carrier-selector formControlName="carrier"></app-carrier-selector>
    <importer-stp-line-selector formControlName="line" [carrierId]="form.value.carrier" [multiple]="false" [trimValue]="true" [type]="'number'"
        (selectedKppIds)="selectedLineKppIds = $event"></importer-stp-line-selector>
    <importer-stp-direction-selector formControlName="direction" [carrierId]="form.value.carrier" [linesKppIds]="selectedLineKppIds"
        [multiple]="false" [type]="'name'"></importer-stp-direction-selector>

    <div class="actions">
        <button mat-raised-button color="sims" type="reset" (click)="handleFormClear()">
            {{'line-direction-counters-resets.clear'| translate | capitalizeFirst }}
        </button>
        <button mat-raised-button color="sims" type="submit" [disabled]="form.invalid || !hasChanged">
            {{'line-direction-counters-resets.lookup'| translate | capitalizeFirst }}
        </button>
    </div>
</form>